/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    SimpleGrid,
    Box,
    Text,
    Image,
    Spinner,
    useToast,
} from "@chakra-ui/react";
import axiosClient from "../../../../api/axiosClient";

export default function ReassignDepartemenDialog({ isOpen, onClose, data, onDepartemenSelect }) {
    const [departemen, setDepartemen] = useState([]);
    const [loading, setLoading] = useState(false);
    const toast = useToast();

    const fetchDepartemen = async () => {
        try {
            setLoading(true);
            const res = await axiosClient.get("/departemen/departemenIT");
            setDepartemen(res.data.data);
        } catch {
            toast({
                title: "Gagal memuat departemen",
                status: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isOpen) fetchDepartemen();
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Dialihkan ke Departemen</ModalHeader>
                <ModalCloseButton />

                <ModalBody pb={6}>
                    {loading ? (
                        <Spinner />
                    ) : (
                        <SimpleGrid columns={2} spacing={6}>
                            {departemen.map((item) => (
                                <Box
                                    key={item.id}
                                    borderWidth="1px"
                                    borderRadius="xl"
                                    p={5}
                                    cursor="pointer"
                                    textAlign="center"
                                    transition="all 0.25s ease"
                                    _hover={{
                                        shadow: "lg",
                                        transform: "translateY(-4px)",
                                        bg: "gray.50",
                                    }}
                                    onClick={() => {
                                        // Tutup dialog departemen
                                        onClose();

                                        // Panggil callback ke parent untuk buka dialog user
                                        onDepartemenSelect(item.id);

                                        toast({
                                            title: `Dialihkan ke ${item.name}`,
                                            status: "success",
                                        });
                                    }}
                                >
                                    {/* IMAGE CIRCLE */}
                                    <Box
                                        mx="auto"
                                        mb={4}
                                        w="120px"
                                        h="120px"
                                        borderRadius="full"
                                        bg="gray.100"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        overflow="hidden"
                                    >
                                        <Image
                                            src={
                                                item.name === "Hardware"
                                                    ? "/images/hardware.png"
                                                    : "/images/software.png"
                                            }
                                            alt={item.name}
                                            maxW="70%"
                                            maxH="70%"
                                            objectFit="contain"
                                            transition="transform 0.3s ease"
                                        />
                                    </Box>

                                    {/* TITLE */}
                                    <Text fontWeight="bold" fontSize="lg">
                                        {item.name}
                                    </Text>
                                </Box>
                            ))}
                        </SimpleGrid>
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}
